import {
   
    FETCH_TICKET_DETAILS_FAILURE,
    FETCH_TICKET_DETAILS_REQUEST,
    FETCH_TICKET_DETAILS_SUCCESS
  } from '../actions/playerTicketAction';
  
  const initialState = {
    
    ticketDetails:{},
    loading: false,
    error: null,
  };
  
  const playerTicketDetailsReducer = (state = initialState, action) => {
    
    switch (action.type) {
      case FETCH_TICKET_DETAILS_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case FETCH_TICKET_DETAILS_SUCCESS:
        console.log('action>>', action);
        return {
          ...state,
          loading: false,
          ticketDetails: action.payload, // Fix here
          error: null,
        };
      case FETCH_TICKET_DETAILS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default playerTicketDetailsReducer;